/** The tutorial page where user is taught how to setup connection between dashboard and printer **/
import React, {Component} from 'react';
import '../css/printer-connecting-tutorial.css';
import 'react-bootstrap';

const PrinterConnectingTutorialPage = () => {
    return <div className="tutorial-page-container">
    <div className="container">
        
        <div className='tutorial-page-subtitle'>Connect Your Printer to Dashboard</div>
        <div className='options-container'>
            <ConnectingOption
                subtitle="Via Printer Touchscreen"
                description={["Ensure that SprintRay Pro is connected to wifi and has internet access. On Pro’s touchscreen, press the ‘Settings’ tab, then the ‘Sprintray Dashboard login’ button. Enter your login credentials into Pro using the onscreen keyboard and press ‘enter’ when finished."]}
                imageSrc="https://sprintray.com/oracle/uploads/2019/02/SprintRay-CTA.png"
                
            />
           
        </div>
        
        

        
    </div>
    
    </div>
}

const ConnectingOption = (props) => {
    const { title, subtitle, comment, description, imageSrc, footer } = props;
    return <div className="option-section">
        <div>
            <div className='option-title'>{ title }</div>
            <div className='option-subtitle'>{ subtitle }</div>
            <div className='option-comment'>{ comment }</div>
            <div className='option-description'>{ description.map(paragraph => <div>{paragraph}</div>) }</div>
            <div className='option-footer'>{ footer }</div>
        </div>
        {/*<div className='option-img'><img src={imageSrc}/></div>*/}
    </div>
}

export default PrinterConnectingTutorialPage;


// WEBPACK FOOTER //
// ./src/components/printer-connecting-tutorial.js